<template>
<div class="chapter">
<div class="inner_page">
<h1 id="heading_id_2" title="Contents">CONTENTS</h1>
<p class="toc"> </p>
<p class="toc_serif"><a href="#/Text/intro"><i>Introduction</i></a></p>
<p class="toc"> </p>
<p class="toc"><b>1</b> | <a href="#/Text/1">A Modern Boat for an Ancient Voyage</a></p>
<p class="toc"><b>2</b> | <span href="#/Text/2" title="Link target outside of Sample">Ancient Olive Groves</span></p>
<p class="toc"><b>3</b> | <span href="#/Text/3" title="Link target outside of Sample">Searching for Wild Olives</span></p>
<p class="toc"><b>4</b> | <span href="#/Text/4" title="Link target outside of Sample">An Ancient Food for Modern Foodies</span></p>
<p class="toc"><b>5</b> | <span href="#/Text/5" title="Link target outside of Sample">Coveting Virginity</span></p>
<p class="toc"><b>6</b> | <span href="#/Text/6" title="Link target outside of Sample">Illumination and Inspiration on the French Riviera</span></p>
<p class="toc"><b>7</b> | <span href="#/Text/7" title="Link target outside of Sample">Ancient Civilizations, Ancient Oil</span></p>
<p class="toc"><b>8</b> | <span href="#/Text/8" title="Link target outside of Sample">The Science of Olives</span></p>
<p class="toc"><b>9</b> | <span href="#/Text/9" title="Link target outside of Sample">How to Live Like a Centenarian</span></p>
<p class="toc"><b>10</b> | <span href="#/Text/10" title="Link target outside of Sample">The Olive Solution</span></p>
<p class="toc"><b>11</b> | <span href="#/Text/11" title="Link target outside of Sample">Something Old and Something New</span></p>
<p class="toc"><b>12</b> | <span href="#/Text/12" title="Link target outside of Sample">The Birthplace of the Olive</span></p>
<p class="toc"> </p>
<p class="toc_serif"><span href="#/Text/epi" title="Link target outside of Sample"><i>Epilogue</i></span></p>
<p class="toc_serif"><span href="#/Text/ack" title="Link target outside of Sample"><i>Acknowledgements</i></span></p>
<p class="toc_serif"><span href="#/Text/notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc_serif"><span href="#/Text/ref" title="Link target outside of Sample"><i>References</i></span></p>
<p class="toc_serif"><span href="#/Text/appa" title="Link target outside of Sample"><i><span class="small">APPENDIX A</span>: Tips on Hosting an Olive Oil Tasting Party</i></span></p>
<p class="toc_serif"><span href="#/Text/appb" title="Link target outside of Sample"><i><span class="small">APPENDIX B</span>: Top Questions about Olive Oil</i></span></p>
<p class="toc_serif"><span href="#/Text/appc" title="Link target outside of Sample"><i><span class="small">APPENDIX C</span>: Olive Oil and Olive Recipes</i></span></p>
<p class="toc_serif"><span href="#/Text/photosection" title="Link target outside of Sample"><i>Photo Section</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?301b1ab4